import { CaseState, ComplaintState, DecisionState, Gender, LinkType, UserStatus } from '@/types/types';
import { categories } from './categories';
import { media } from './media';
import { sectors } from './sectors';
import { reaches } from './reaches';

export const complaintAndCaseCategorieOptions = categories
	.filter((c) => !c.isFromCodeOfEthics)
	.map((category) => {
		return {
			label: category.name,
			value: {
				number: category.number,
			},
		};
	});

export const getCategoriesFromCodeOfEthics = (categories) => {
	const result = [];

	const recurse = (categoryList) => {
		for (const category of categoryList) {
			if (category.isFromCodeOfEthics) {
				result.push({
					label: category.name,
					value: {
						number: category.number,
					},
				});
			}
			if (category.children) {
				recurse(category.children);
			}
		}
	};

	recurse(categories);
	return result;
};

export const decisionCategoryOptions = getCategoriesFromCodeOfEthics(categories);

export const mediaOptions = media.map((media) => {
	return {
		label: media.name,
		value: {
			name: media.name,
		},
	};
});

export const sectorOptions = sectors.map((sector) => {
	return {
		label: sector.name,
		value: {
			name: sector.name,
		},
	};
});

export const reachOptions = reaches.map((reach) => {
	return {
		label: reach.name,
		value: {
			name: reach.name,
		},
	};
});

export const linkTypeOptions = Object.keys(LinkType).map((key) => {
	switch (key) {
		case 'Other':
			return { label: 'Sonstige', value: LinkType.Other };
		default:
			return { label: key, value: LinkType[key] };
	}
});

export const attachmentOptions = [
	{ label: 'Ja', value: true },
	{ label: 'Nein', value: false },
];

export const complaintStateOptions = [
	{ label: 'Nicht zugewiesen', value: ComplaintState.NotAssigned },
	{ label: 'Zugewiesen', value: ComplaintState.Assigned },
	{ label: 'Nicht zuständig', value: ComplaintState.NotResponsible },
];

export const caseStateOptions = [
	{ label: 'Kein Status', value: CaseState.NoStatus },
	{ label: 'Prüfung kleiner Senat', value: CaseState.ExaminationSmallSenate },
	{ label: 'Stellungnahmen', value: CaseState.Statements },
	{ label: 'Prüfung Werberat', value: CaseState.ExaminationWerberat },
	{ label: 'Entscheidung Sensibilisierung', value: CaseState.DecisionSensitization },
	{ label: 'Entscheidung keine Gründe', value: CaseState.DecisionNoReason },
	{ label: 'Entscheidung Stopp', value: CaseState.DecisionStop },
	{ label: 'Sofortige Sujetrücknahme', value: CaseState.ImmediateSubjectWithdrawal },
	{ label: 'Nicht zuständig', value: CaseState.NotResponsible },
	{ label: 'Verfahren nicht möglich', value: CaseState.ProcedureNotPossible },
	{ label: 'Als unbegründet abgewiesen', value: CaseState.Unfounded },
];

export const decisionStateOptions = [
	{ label: 'Kein Status', value: DecisionState.Null },
	{ label: 'Entscheidung: Kein Grund', value: DecisionState.NoReason },
	{ label: 'Befangen', value: DecisionState.Biased },
	{ label: 'Entscheidung: STOP', value: DecisionState.Stop },
	{ label: 'Entscheidung: Sensibilisierung', value: DecisionState.Awareness },
	{ label: 'In den Rat', value: DecisionState.GoSmallSenate },
	{ label: 'Entscheidung: STOP (kleiner Senat)', value: DecisionState.StopSmallSenate },
	{ label: 'Nicht anwesend', value: DecisionState.UserAbsent },
];

export const userStatusOptions = [
	{ label: 'Aktiv', value: UserStatus.Active },
	{ label: 'Deaktiviert', value: UserStatus.Deactivated },
	{ label: 'Ausstehend', value: UserStatus.Pending },
	{ label: 'Abwesend', value: UserStatus.Absent },
];

export const isPublicOptions = [
	{ label: 'Ja', value: true },
	{ label: 'Nein', value: false },
];

export const isSharedOptions = [
	{ label: 'Ja', value: true },
	{ label: 'Nein', value: false },
];

export const reasonOptions = [
	{ label: 'Ja', value: true },
	{ label: 'Nein', value: false },
];

export const hasSealOptions = [
	{ label: 'Ja', value: true },
	{ label: 'Nein', value: false },
];

export const decisionPercentOptions = [
	{ label: 'Ja', value: true },
	{ label: 'Nein', value: false },
];

export const userRoleOptions = [
	{
		label: 'Admin',
		value: {
			name: 'Admin',
		},
	},
	{
		label: 'Werberat',
		value: {
			name: 'Werberat',
		},
	},
	{
		label: 'Junger Werberat',
		value: {
			name: 'Junger Werberat',
		},
	},
	{
		label: 'Kleiner Senat A',
		value: {
			name: 'Kleiner Senat A',
		},
	},
	{
		label: 'Kleiner Senat B',
		value: {
			name: 'Kleiner Senat B',
		},
	},
	{
		label: 'Vorstand',
		value: {
			name: 'Vorstand',
		},
	},
];

export const contactRoleOptions = [
	{
		label: 'Unternehmen',
		value: {
			name: 'Unternehmen',
		},
	},
	{
		label: 'Agenturen',
		value: {
			name: 'Agenturen',
		},
	},
	{
		label: 'Arbeiterkammer',
		value: {
			name: 'Arbeiterkammer',
		},
	},
	{
		label: 'Antisexismus-Beirat',
		value: {
			name: 'Antisexismus-Beirat',
		},
	},
	{
		label: 'Lebensmittel-Fachbeirat',
		value: {
			name: 'Lebensmittel-Fachbeirat',
		},
	},
];

export const timePeriodOptions = [
	{ label: 'Heute', value: 'today', checked: false },
	{ label: 'Diese Woche', value: 'week', checked: false },
	{ label: 'Dieser Monat', value: 'month', checked: false },
];

export const genderOptions = [
	{ label: 'Herr', value: Gender.Male },
	{ label: 'Frau', value: Gender.Female },
];

export const returnFormOptions = (key, withBitteWaehlenOption = false, withAlleOption = false) => {
	let options = [];
	switch (key) {
		case 'complaintAndCaseCategories':
			options = complaintAndCaseCategorieOptions;
			break;
		case 'decisionCategories':
			options = decisionCategoryOptions;
			break;
		case 'media':
			options = mediaOptions;
			break;
		case 'attachment':
			options = attachmentOptions;
			break;
		case 'sector':
			options = sectorOptions;
			break;
		case 'complaintStateOptions':
			options = complaintStateOptions;
			break;
		case 'caseStateOptions':
			options = caseStateOptions;
			break;
		case 'caseStateDecisionsOptions':
			options = caseStateOptions.filter((state) =>
				[
					CaseState.DecisionSensitization,
					CaseState.DecisionNoReason,
					CaseState.DecisionStop,
					CaseState.ImmediateSubjectWithdrawal,
					CaseState.NotResponsible,
					CaseState.ProcedureNotPossible,
					CaseState.Unfounded,
				].includes(state.value),
			);
			break;
		case 'isPublic':
			options = isPublicOptions;
			break;
		case 'timePeriod':
			options = timePeriodOptions;
			break;
		case 'gender':
			options = genderOptions;
			break;
		case 'linkType':
			options = linkTypeOptions;
			break;
		case 'decisionStateOptions':
			options = decisionStateOptions;
			break;
		case 'smallSenateDecisionStateOptions':
			options = smallSenateDecisionStateOptions;
			break;
		case 'isShared':
			options = isSharedOptions;
			break;
		case 'reason':
			options = reasonOptions;
			break;
		case 'userRole':
			options = userRoleOptions;
			break;
		case 'contactRole':
			options = contactRoleOptions;
			break;
		case 'userStatus':
			options = userStatusOptions;
			break;
		case 'decisionPercent':
			options = decisionPercentOptions;
			break;
		case 'hasSeal':
			options = hasSealOptions;
			break;
		case 'reach':
			options = reachOptions;
			break;
		default:
			break;
	}

	if (withAlleOption === true) {
		if (!options.find((option) => option.label === 'Alle')) options.unshift({ label: 'Alle', value: null });
	} else {
		options = options.filter((option) => option.label !== 'Alle');
	}

	if (withBitteWaehlenOption === true) {
		if (!options.find((option) => option.label === 'Bitte wählen')) options.unshift({ label: 'Bitte wählen', value: null });
	} else {
		options = options.filter((option) => option.label !== 'Bitte wählen');
	}

	return options;
};
